import script from "./OfNavbarTop.vue?vue&type=script&setup=true&lang=js"
export * from "./OfNavbarTop.vue?vue&type=script&setup=true&lang=js"

import "./OfNavbarTop.vue?vue&type=style&index=0&id=01a969f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01a969f3"]])

export default __exports__